import { newrelic } from "@jti/fe-clients";
import type { OrderItem } from "@jti/magento";

import type { SummaryItem } from "@checkout-v2/features/ItemsSummary/ItemsSummaryView";

import { mapBundleOrderItemToSummaryItem } from "../mapBundleOrderItemToSummaryItem";
import { mapSimpleOrderItemToSummaryItem } from "../mapSimpleOrderItemToSummaryItem";

export const mapOrderItemToSummaryItem = (
  orderItem: OrderItem,
  displayBundleSelectedItems: boolean = false,
  displayBundleSelectedItemsPrices: boolean = false,
  showPricesWithTaxExcluded: boolean = false
): SummaryItem | null => {
  switch (orderItem.product_type) {
    case "simple":
      return mapSimpleOrderItemToSummaryItem(orderItem, showPricesWithTaxExcluded);

    case "bundle":
      return mapBundleOrderItemToSummaryItem(
        orderItem,
        displayBundleSelectedItems,
        displayBundleSelectedItemsPrices,
        showPricesWithTaxExcluded
      );

    default:
      newrelic.noticeError(new Error(`Unsupported order item type: ${orderItem.product_type}`));
      return null;
  }
};
